export const GET_PO_DETAILS = "GET_PO_DETAILS"
export const GET_PO_ATTACHMENTS = "GET_PO_ATTACHMENTS"
export const GET_PO_ATTACHMENTSLIST = "GET_PO_ATTACHMENTSLIST"
export const SET_APPROVER_RESPONSE = "SET_APPROVER_RESPONSE"
